const useNewDomain = process.env.REACT_APP_USE_NEW_DOMAIN === 'true';

export const DOMAIN = useNewDomain ? 'bambus.at' : 'bambus.io';
export const HOME_URL = `https://www.${DOMAIN}`;
export const EMAIL = `beratung@${DOMAIN}`;
export const DATENSCHUTZ_URL = `https://www.${DOMAIN}/datenschutz/`;
export const IMPRESSUM_URL = `https://www.${DOMAIN}/impressum/`;
